import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"

export class NotificationsController {

    /* STATIC */
    public static async build(type: string, text: string): Promise<void> {
        switch (type) {
            case "error":
                await this.create(text, "#ff0000");
                break;
            case "info":
                await this.create(text, "#009739");
                break;
            default:
                await this.create(text, "#009739");
                break;
        }
    }

    private static async create(text: string, style: string): Promise<void> {
        Toastify({
            text: text,
            duration: 3000,
            close: true,
            gravity: "bottom",
            position: "center",
            stopOnFocus: true,
            style: {
                background: style,
                minHeight: "80px",
                borderRadius: "8px",
                color: "#000000",
                display: "flex",
                alignItems: "center",
                fontFamily: "Arial",
            }
        }).showToast();
    }

}
